import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Matt McMahon · Portfolio & Blog</p>
        <h1>Welcome to Matt McMahon's Professional Hub</h1>
        <p className="lede">
          Explore my portfolio, insights, and achievements. This site showcases my work and thoughts, 
          providing a glimpse into my professional journey and creative endeavors.
        </p>
        <div className="cta-row">
          <a href="#portfolio" target="_self">
            View My Portfolio
          </a>
          <a href="#blog" target="_self" className="secondary">
            Read My Blog
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Showcase Your Work</h2>
          <p>
            Discover my projects and the impact they have made. Each piece reflects my dedication to quality and innovation.
          </p>
        </article>
        <article>
          <h2>Insights & Ideas</h2>
          <p>
            Dive into my blog for articles on industry trends, personal reflections, and professional tips to inspire your journey.
          </p>
        </article>
        <article>
          <h2>Connect with Me</h2>
          <p>
            Let's collaborate! Reach out for inquiries, networking, or just to say hello. I'm always open to new opportunities.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;